import '../../scripts/common';

import '../../scripts/autosize';
import 'animate.css/animate.css';
import '../../scripts/animate';
import '../../scripts/picture';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumbs from '../../components/base/Breadcrumbs';
import Checkbox from '../../components/base/Checkbox';
import Select from '../../components/base/Select';
import Categories from '../../components/simple/Categories';
import ProductCard from '../../components/ProductCard';
import ProductsList from '../../components/ProductsList';
import ProductQuickView from '../../components/ProductQuickView';
import ArticleCard from '../../components/ArticleCard';
import ArticlesList from '../../components/ArticlesList';
import Popup from '../../components/base/Popup';
import DiagnosticsPreview from '../../components/DiagnosticsPreview';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
// import MainPreloader from '../../scripts/main-preloader';
import { media } from '../../scripts/helpers';

import './styles.css';
import '../../styles/product-outlet.css';

import product1 from '../../images/content/product_1.jpg';
import product2 from '../../images/content/product_2.jpg';
import product3 from '../../images/content/product_3.jpg';
import product4 from '../../images/content/product_4.jpg';
import product5 from '../../images/content/product_5.jpg';

import nameplate1 from '../../images/content/nameplate_1.jpg';
import nameplate2 from '../../images/content/nameplate_2.jpg';
import article1 from '../../images/content/article_1.jpg';
import article2 from '../../images/content/article_2.jpg';
import article3 from '../../images/content/article_3.jpg';

import '../../images/sprite/star.svg';
import '../../images/sprite/view.svg';
import '../../images/sprite/cross.svg';
import '../../images/responsive/noPhotoBig.jpg';
import '../../images/responsive/noPhotoSmall.jpg';

import '../../images/sprite/category_hair.svg';
import '../../images/sprite/category_sun.svg';
import '../../images/sprite/category_child.svg';
import '../../images/sprite/category_face.svg';
import '../../images/sprite/category_body.svg';

import '../../images/sprite/hair_lg.svg';
import '../../images/sprite/hand_lg.svg';
import '../../images/sprite/body_lg.svg';
import '../../images/sprite/face_lg.svg';
import '../../images/sprite/man_lg.svg';
import '../../images/sprite/woman_lg.svg';

import '../../images/sprite/klorane_logo.svg';

// import banner1 from '../../images/content/banner_1.jpg';
const url = window.location.pathname;

// eslint-disable-next-line func-names
$('#geturl').click(function() {
    $('#geturl').attr({
        href: url,
    });
});

$(() => {
    Header.create();
    Footer.create();
    Breadcrumbs.create();
    Categories.create();
    Checkbox.create();
    ProductsList.create();
    initCoreElements();
    DiagnosticsPreview.create();
    ArticlesList.create();
    PageScrollBtn.create();
});

const productImages = { product1, product2, product3, product4, product5 };
const productNameplates = { nameplatesProduct2: [nameplate1, nameplate2] };

function initCoreElements() {
    initSelect();
    initArticleCard();
    initProductCard();
    initPopup();
    initFilter();
    initShowMore();
}

/**
 * Инициализация карточек товара
 */
function initProductCard() {
    $('.product-card').each((i, item) => {
        let num = 1;

        if (/\d/.test(item.id)) {
            const regMatch = Number(item.id.match(/\d+/)[0]);
            num = regMatch % 4 ? regMatch % 4 : 4;
        }

        const productDefault = new ProductCard($(item));
        productDefault.init({
            picture: productImages[`product${num}`],
            nameplates: productNameplates[`nameplatesProduct${num}`],
        });
    });

    ProductQuickView.create();
}

/**
 * Инициализация селектов
 */
function initSelect() {
    const select = new Select($('.select--catalog-sort'));
    select.init({ isSearch: false });
}

const articlesImages = {
    article1,
    article2,
    article3,
};

/**
 * Инициализация карточек статей
 */
function initArticleCard() {
    $('.article-card').each((i, item) => {
        const num = /\d+/g.test(item.id) ? item.id.match(/\d+/g)[0] : 1;
        const articleDefault = new ArticleCard($(item));
        articleDefault.init({
            picture: articlesImages[`article${num}`],
        });
    });
}

/**
 * Активация попапов
 */
function initPopup() {
    Popup.create();
}

/**
 * Сортировка и фильтр
 */
function initFilter() {
    // Поля фильтра
    $('input[type="checkbox"]', getForm()).on('change', result => updatePageFilter(result));
    $('input[type="checkbox"]').change(e => {
        const topOffset = $(e.target).offset();
        $(document).ajaxSuccess(() => {
            $('.js-catalog-desktop-filter-wrapper').scrollTop(topOffset.top + 40);
        });
    });

    // Сортировка
    $('#select-catalog-sort').on('change', result => updatePageSort(result));
}

/**
 *
 */
function getForm() {
    return $('#catalog-filter');
}

/**
 * Обновление содержимого страницы после сортировки
 */
function updatePageSort() {
    const $wrapper = $('#catalog-filter');
    const fd = new FormData(getForm()[0]);
    window.history.pushState('', '', `?${getForm().serialize()}`);
    // MainPreloader.show();
    $.ajax({
        url: `/api/internal/component/catalog:catalog.index${window.location.search}`,
        data: fd,
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
    }).done(result => {
        $wrapper.html(result);
        initCoreElements();
        initCategorySelect();
        if ($(window).width() < 1023) {
            $('.js-catalog-desktop-filter-wrapper').hide();
        }
    });
    // .always(() => {
    //     MainPreloader.fadeOut();
    // });
}

/**
 * Обновление содержимого страницы после фильтрации
 */
function updatePageFilter() {
    const $wrapper = $('#catalog-filter');
    const fd = new FormData(getForm()[0]);

    window.history.pushState('', '', `?${getForm().serialize()}`);
    // MainPreloader.show();
    $.ajax({
        url: `/api/internal/component/catalog:catalog.index${window.location.search}`,
        data: fd,
        cache: false,
        contentType: false,
        processData: false,
        method: 'POST',
    }).done(result => {
        $wrapper.html(result);
        initCoreElements();
        initCategorySelect();
    });
    // .always(() => {
    //     MainPreloader.fadeOut();
    // });
}

/**
 * Переинициализация селекта выбора категорий после ajax done в updatePage()
 */
function initCategorySelect() {
    const $selectCategories = $('.select--categories');
    if ($selectCategories.length) {
        const select = new Select($selectCategories);
        select.init({ isSearch: false });
    }
}

/**
 *
 */
function initShowMore() {
    $('.js-catalog-show-more').on('click', function() {
        const $showMoreButton = $(this);
        const $wrapper = $('.js-catalog-products-list');
        var currentPage = $wrapper.data('page');
        var sectionId = $wrapper.data('category-id');
        var totalCount = $wrapper.data('total-count');
        var perPage = $wrapper.data('per-page');
        var outlet = $(this).data('outlet');

        /* MainPreloader.show(); */

        $.post(`/api/internal/component/catalog:catalog.index${window.location.search}`, {
            page: currentPage + 1,
            showMore: true,
            SECTION_ID: sectionId,
            outlet,
        }).done(result => {
            $wrapper.append(result);
            $wrapper.data('page', currentPage + 1);

            if ((currentPage + 1) * perPage >= totalCount) {
                $showMoreButton.hide();
            }
        });
        /* .always(() => {
                MainPreloader.fadeOut();
            }); */
    });
}

$(document).on('click', '.catalog__btn-filters-mobile', () => {
    $('.js-catalog-desktop-filter-wrapper').fadeIn(100);
});

$(document).on('click', '.catalog-filters__submit', () => {
    $('.js-catalog-desktop-filter-wrapper').fadeOut(100);
});

$(document).on('click', '.catalog-mobile-filter__close', () => {
    $('.js-catalog-desktop-filter-wrapper').fadeOut(100);
});

/**
 * Перенос блока фильтров в popup-обёртку на смартфонах
 * И обратно на десктопе
 */
const tabletLgMedia = media('tabletLg');
const handleMediaPopupFilter = mq => {
    if (mq.matches) {
        $('.js-catalog-desktop-filter-wrapper').fadeOut(0);
    } else {
        $('.js-catalog-desktop-filter-wrapper').fadeIn(0);
    }
};

tabletLgMedia.addListener(handleMediaPopupFilter);
handleMediaPopupFilter(tabletLgMedia);

/**
 * Если при ресайзе попап с фильтрами остается открытым, закрываем его
 */
// let timerId;
// $(window).on('resize', () => {
//     clearTimeout(timerId);

//     timerId = setTimeout(() => {
//         if ($('.popup--catalog-filters.is-open').length && $(window).width() >= 1024) {
//             Popup.getInstance($('.popup--catalog-filters.is-open')).close();
//         }
//     }, 200);
// });
